import React from "react";

import { CircularProgress } from "@mui/material";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./CircularProgressLoader.module.css";

interface Props {
  isLoading: boolean;
  innerWidthHeight?: number;
  outerWidthHeight?: number;
  className?: string;
}

const CircularProgressLoader: React.FC<Props> = ({
  isLoading,
  innerWidthHeight = 20,
  outerWidthHeight = 30,
  className,
}) => {
  return (
    <>
      {isLoading && (
        <div
          className={toClassName(styles.container, className)}
          style={{
            width: `${outerWidthHeight}px`,
            height: `${outerWidthHeight}px`,
          }}
        >
          <CircularProgress color={"inherit"} size={innerWidthHeight} />
        </div>
      )}
    </>
  );
};

export default CircularProgressLoader;
